import PropTypes from 'prop-types';
import React, { useMemo, useCallback } from 'react';
import Pluralize from 'react-pluralize';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './FontsList.scss';

import AddButton from './AddButton';

function FontsList(props) {
  const { list, upload } = props;
  const InsertBtn = useCallback(() => <AddButton upload={upload} />, [upload]);
  const options = useMemo(
    () => ({
      insertBtn: InsertBtn,
      defaultSortName: 'name',
      defaultSortOrder: 'asc',
    }),
    [upload],
  );

  return (
    <div className="fonts-list-container">
      <h3>
        <Pluralize singular="Font" plural="Fonts" count={list.length} />
      </h3>
      <BootstrapTable
        data={list}
        options={options}
        insertRow
        striped
        hover
        pagination
        bodyContainerClass="list-body-container"
        tableStyle={{ border: 'none' }}
      >
        <TableHeaderColumn
          isKey
          dataField="name"
          dataSort
          filter={{ type: 'TextFilter', defaultValue: '' }}
        >
          Name
        </TableHeaderColumn>
        <TableHeaderColumn dataField="size" dataSort>
          Size
        </TableHeaderColumn>
        <TableHeaderColumn dataField="modified" dataSort>
          Last Modified
        </TableHeaderColumn>
      </BootstrapTable>
    </div>
  );
}

FontsList.propTypes = {
  list: PropTypes.array,
  upload: PropTypes.func,
};

export default withRouter(FontsList);
